/*
 *  Controller to show blinkup page for Developer Enroll
*/

import Radio from 'backbone.radio';
import BlinkupView from '@/views/blinkup_layout';
import session from '@/models/v5/session';
    var globalCh = Radio.channel('global');
    var routerCh = Radio.channel('router');

    function show_blinkup() {

        function show_blinkup_view() {
            var blinkup_view = new BlinkupView();
            app_container.showChildView('container', blinkup_view);
            globalCh.request('show_secondary_nav', { empty: true });
            routerCh.request('set_location', 'blinkup', primary);
        }
        
        var app_container = globalCh.request('app_layout');
        var primary = globalCh.request('primary_account');

        let calls = [];
        calls.push(session.getPlanAndTokenId());
        primary.proxies.each( function(proxy) {
            calls.push(primary.fetch_permissions_for_account(proxy));
        });


        Promise.all(calls).then(show_blinkup_view).catch(function(e){ console.warn(e); });

    }

    export default show_blinkup;

